(function () {
  // Constants
  const currentScript = document.currentScript;
  const containsInflightExclusiveItems = Boolean(currentScript.dataset.exclusive === 'true');

  // Early return
  if (!containsInflightExclusiveItems) return;

  // On load
  document.addEventListener('DOMContentLoaded', function () {
    // Functions
    function retryRequest(fn, retries = 3, delay = 1000, attempt = 1) {
      return fn().catch(function (error) {
        if (attempt >= retries) {
          console.error('Max retries reached. Request failed:', error);
          throw error;
        }
        const nextDelay = delay * Math.pow(2, attempt);
        console.warn(`Retrying... Attempt ${attempt + 1} in ${nextDelay}ms`, error);
        return new Promise(function (resolve) {
          setTimeout(resolve, nextDelay);
        }).then(function () {
          return retryRequest(fn, retries, delay, attempt + 1);
        });
      });
    }

    function getIpAddress() {
      return retryRequest(function () {
        return fetch('https://api.ipify.org?format=json')
          .then(function (response) {
            return response.json();
          });
      });
    }

    function updateIpAddressOnCart() {
      return getIpAddress()
        .then(function (data) {
          if (!data.ip) {
            console.error('Invalid IP data:', data);
            throw new Error('Invalid IP data received');
          }

          // Cart update request
          const cartUpdateURL = window.Shopify.routes.root + 'cart/update.js';
          const cartUpdateOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                ip_address: data.ip,
                action: 'CHECKOUT_START',
              },
            }),
          };

          return retryRequest(function() {
            return fetch(cartUpdateURL, cartUpdateOptions)
              .then(function (response) {
                return response.json();
              });
            });
        })
        .then(function (response) {
          if (response.attributes) {
            return {
              success: true,
              message: 'Success'
            }
          } else if (response.status >= 400 && response.status < 500) {
            return {
              success: false,
              message: response.message
            }
          }
        })
        .catch(function (error) {
          console.error('Error updating cart:', error);
        });
    }

    function displayErrorMessage(errorMessage) {
      // Helper function to slide down an element
      function slideDown (target, duration = 500, checkHidden = true) {
        let display = window.getComputedStyle(target).display;
        if (checkHidden && display !== 'none') {
          return;
        }
        target.style.removeProperty('display');
        if (display === 'none') display = 'block';
        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(()=>{
          target.style.removeProperty('height');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
          target.style.removeProperty('transition-timing-function');
        }, duration);
      }

      // Helper function to slide up an element
      function slideUp(target, duration = 500) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(()=>{
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
          target.style.removeProperty('transition-timing-function');
        }, duration);
      }

      function addErrorToDOM(errorDisplayElement) {
        const errorsHTML = `<p>${errorMessage}</p>`;
        errorDisplayElement.innerHTML = errorsHTML;
        slideDown(errorDisplayElement);
      }

      // Display the error message
      const errorDisplayElement = document.querySelector('[data-form-errors]');
      if (errorDisplayElement.childElementCount > 0) {
        slideUp(errorDisplayElement);
        setTimeout(() => {
          errorDisplayElement.innerHTML = '';
          addErrorToDOM(errorDisplayElement);
        }, 500);
      } else {
        addErrorToDOM(errorDisplayElement);
      }
    }

    // Event listener
    const cartForm = document.querySelector('[data-cart-form] form[action="/cart"]');
    cartForm.addEventListener('submit', function (event) {
      event.preventDefault();

      updateIpAddressOnCart().then(function (result) {
        if (result.success) {
          window.location.href = '/checkout';
        } else {
          displayErrorMessage(result.message)
        }
      });
    });
  });
})();
